<div class="shareLinkDialog">
    <sync-dialog [config]="{
        title: 'Share via email',
        subTitle: fileName,
        isClosable: true,
        closeIcon:'arrow-left',
        onCloseIcon: onBack,
        actionButton: 'Send',
        cancelButton: 'Back',
        onActionClick: onSubmit,
        onCancelClick: closeShareLinkDialog,
        isButtonLoading: isButtonLoading,
        isActionButtonDisabled: isSendButtonDisabled()
    }" [open]="showShareLinkDialog" [isFullScreen]="false" [onClose]="closeAfterSendLink">
    <div class="share-via-email-body">
        <sync-chip-email [disabled]="false" [label]="'Email addresses'" [readOnly]="false"
                    [errorMessage]="errorMessage" [placeholder]="'Email addresses'"
                    [chipItems]="emailItems" [onChipValueChange]="onEmailChange"
                    [chipLeadAdornment]="{
                        enabled: true,
                        type: 'avatar',
                        size: 'large',
                        avatarConfig: { type: 'avatar', size: 24, randomColor:true }
                    }"
                    >
        </sync-chip-email>
        <div *ngIf="isPro && !isOnTrial">
            <sync-textarea
                [label]="'Message (optional)'"
                [inputChange]="onChangeMessage"
                (keydown)="onKeyDown($event)"
                [rows]="3">
            </sync-textarea>
        </div>
    </div>
    </sync-dialog>
</div>
